import Action from "./Action";
import { applyPatch } from "rfc6902";
import {
	AddOperation,
	MoveOperation,
	Operation,
	RemoveOperation,
	ReplaceOperation
} from "rfc6902/diff";

abstract class PatchAction implements Action {
	private readonly applyPatch: Operation;
	private readonly revertPatch: Operation;

	constructor(apply: Operation, revert: Operation) {
		this.applyPatch = apply;
		this.revertPatch = revert;
	}

	public apply<S>(state: S): S {
		const newState = JSON.parse(JSON.stringify(state));
		applyPatch(newState, [this.applyPatch]);
		return newState;
	}

	public revert<S>(state: S): S {
		const newState = JSON.parse(JSON.stringify(state));
		applyPatch(newState, [this.revertPatch]);
		return newState;
	}

	public patches(): Operation[] {
		return [{ ...this.applyPatch }];
	}
}

export class AddAction extends PatchAction {
	constructor(path: string, value: unknown) {
		const apply: AddOperation = { op: "add", path: path, value: value };
		const revert: RemoveOperation = { op: "remove", path: path };
		super(apply, revert);
	}
}

export class MoveAction extends PatchAction {
	constructor(oldPath: string, newPath: string) {
		const apply: MoveOperation = { op: "move", from: oldPath, path: newPath };
		const revert: MoveOperation = { op: "move", from: newPath, path: oldPath };
		super(apply, revert);
	}
}

export class ReplaceAction extends PatchAction {
	constructor(path: string, oldValue: unknown, newValue: unknown) {
		const apply: ReplaceOperation = { op: "replace", path: path, value: newValue };
		const revert: ReplaceOperation = { op: "replace", path: path, value: oldValue };
		super(apply, revert);
	}
}

export class DeleteAction extends PatchAction {
	constructor(path: string, value: unknown) {
		const apply: RemoveOperation = { op: "remove", path: path };
		const revert: AddOperation = { op: "add", path: path, value: value };
		super(apply, revert);
	}
}
